import { useState } from "react";

const useEditMode = (blockId) => {
    const [editMode, setEditMode] = useState(false);
    const [currentBlock, setCurrentBlock] = useState(null)

    const onClick = (e) => {
        if (e.stopPropagation) {
            e.stopPropagation();
        }
        setEditMode(true);
        setCurrentBlock(blockId);
    };

    return {
        editMode,
        onClick,
        setEditMode,
        currentBlock
    };
};

export default useEditMode;